import { render } from "./strukturOrganisasi.vue?vue&type=template&id=c3739038"
import script from "./strukturOrganisasi.vue?vue&type=script&lang=js"
export * from "./strukturOrganisasi.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__